module.exports = __webpack_public_path__ + "img/sitelogo.e2b2e22b.png";